<div class="ribbon" [ngClass]="[location, type]">
  {{ content }}
</div>
